import { GET_ALL_PROJECT_NUMBER, GET_ALL_PO_DETAILS, GET_ALL_SMS_DOCUMENTS, GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER_DOCUMENTS, } from '../type'


const initialState = {

    allProjectNumber: [],
    allPoDetails: [],
    allSmsDocs: [],
    allSupplierDocs: [],
}

export default function projectNoReducer(state = initialState, action) {
    switch (action.type) {

        case GET_ALL_PROJECT_NUMBER:
            return {
                ...state,
                allProjectNumber: action.payload,
                loading: false
            }
        case GET_ALL_PO_DETAILS:
            return {
                ...state,
                allPoDetails: action.payload,
                loading: false
            }
        case GET_ALL_SMS_DOCUMENTS:
            return {
                ...state,
                allSmsDocs: action.payload,
                loading: false
            }
        case GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER_DOCUMENTS:
            return {
                ...state,
                allSupplierDocs: action.payload,
                loading: false
            }
        default: return state
    }

}